import { uploadFileToFileShare } from './file-intake-client';

/**
 * Upload a single file to /upload/direct and return the attachment payload used by shared UI flows.
 */
export async function uploadFile(file: File, entityType?: string, entityId?: string): Promise<{
  fileUrl: string;
  fileName: string;
  mimeType: string;
  fileId?: string;
}> {
  const uploaded = await uploadFileToFileShare(file, {
    entityType,
    entityId,
    source: 'upload',
    sourceChannel: 'web_upload',
    autoAnalyze: false,
  });
  return {
    fileUrl: uploaded.fileUrl,
    fileName: uploaded.fileName,
    mimeType: uploaded.mimeType,
    fileId: uploaded.fileId,
  };
}

/**
 * Convert a data URL (for example a signature PNG) into a File and upload it with the shared pipeline.
 */
export async function uploadDataUrl(dataUrl: string, fileName: string, entityType?: string, entityId?: string): Promise<{
  fileUrl: string;
  fileName: string;
  mimeType: string;
  fileId?: string;
}> {
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  const file = new File([blob], fileName, { type: blob.type || 'image/png' });
  return uploadFile(file, entityType, entityId);
}

/**
 * Upload multiple files in parallel and return the attachment payload array.
 */
export async function uploadFiles(files: File[], entityType?: string, entityId?: string) {
  return Promise.all(files.map((file) => uploadFile(file, entityType, entityId)));
}
